export default __webpack_public_path__ + "static/media/footer-applestore.6d688392.svg";